import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { usageTracker } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export function ResetFiltersButton({
  screen
}) {
  const {
    resetFilters,
    resetSort,
    setSearchString
  } = useTicketListingsSortAndFilters();
  return /*#__PURE__*/_jsx(Button, {
    use: "primary",
    onClick: () => {
      usageTracker.track('Customer Portal App', 'Tickets Discovered', {
        action: 'tickets-filter-cleared',
        screen
      });
      resetFilters();
      resetSort();
      setSearchString('');
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-portal-app.filters.resetFilters"
    })
  });
}